import { type FC } from "react"
import { type ITextSubHeader } from "./interface"
import "./index.scss"

const TextSubHeader: FC<ITextSubHeader> = (props) =>
    <p className="text-sub-header" {...props}/>

export default TextSubHeader
